import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { FormOption } from '@shared/forms';
import { Departments, GetDepartmentsLookupValue, GetDepartmentsValue } from '../models';

export const departmentsActions = createActionGroup({
    source: 'Departments',
    events: {
        'Get Departments': props<{ value: GetDepartmentsValue }>(),
        'Get Departments Success': props<{ payload: Departments }>(),
        'Get Departments Error': props<{ code: number }>(),

        'Get Departments Lookup': props<{ value: GetDepartmentsLookupValue }>(),
        'Get Departments Lookup Success': props<{ payload: FormOption<string>[] }>(),
        'Get Departments Lookup Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
